module.exports = __webpack_public_path__ + "img/schneider-electric.9569ee42.png";